import { formatUsd } from "../../config/trading";
import { TableHeader } from "./TableHeader";

const TRADE_COLUMNS = ["Side", "Pair", "Notional", "Status"];

export function OrderHistory({ trades }) {
  return (
    <div className="panel trades-panel" data-testid="recent-trades-panel">
      <div className="panel-head"><span className="label">RECENT FILLS</span></div>
      <div className="table-like">
        <TableHeader variant="trade" testId="recent-trades-table-header" columns={TRADE_COLUMNS} />
        {trades.length === 0 && <div className="empty" data-testid="recent-trades-empty">No paper fills yet</div>}
        {trades.slice(0, 6).map((trade) => (
          <div className="trade-row" key={trade.id} data-testid={`trade-${trade.id}-row`}>
            <span className={trade.side === "buy" ? "positive" : "negative"}>{trade.side.toUpperCase()}</span>
            <span>{trade.symbol}</span>
            <span className="mono">{formatUsd(trade.notional)}</span>
            <span>{trade.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}